import * as actionTypes from '../../constants/actionTypes';

export const ERROR_TIMEOUT = 5000;

export const setRequestInProcess = (inProcess, requestType) => {
  return {
    type: actionTypes.SET_REQUEST_IN_PROCESS,
    requestType,
    inProcess,
  };
};

export const setRequestProgress = (loaded, total, requestType) => {
  return {
    type: actionTypes.SET_REQUEST_PROGRESS,
    requestType,
    loaded,
    total,
  };
};

let errorTimer = null;

const sendError = (payload) => {
  return {
    type: actionTypes.SET_ERROR,
    payload,
  };
};

const sendLocalError = (payload) => {
  return {
    type: actionTypes.SET_LOCAL_ERROR,
    payload,
  };
};

export const stopTimer = () => {
  if (errorTimer) {
    clearTimeout(errorTimer);
  }
};

export const clearError = () => {
  if (errorTimer) {
    clearTimeout(errorTimer);
    errorTimer = null;
  }
  return {
    type: actionTypes.CLEAR_ERROR,
  };
};

export const clearLocalError = () => {
  return {
    type: actionTypes.CLEAR_LOCAL_ERROR,
  };
};

/**
 * @param error { message?: string }
 * @param ignored : boolean
 */
export const setError =
  (error, ignored = false) =>
  (dispatch) => {
    if (ignored) {
      dispatch(sendLocalError(error));
    } else {
      dispatch(sendError(error));
      if (errorTimer) {
        clearTimeout(errorTimer);
        errorTimer = null;
      }

      errorTimer = setTimeout(() => {
        dispatch(clearError());
      }, ERROR_TIMEOUT);
      return sendError(error);
    }
  };
